module.exports = __webpack_public_path__ + "img/1.96112a2e.png";